import { combineReducers } from 'redux';

import applications from './applications';
import comments from './comments';
import jobs from './jobs';
import me from './me';
import org from './org';

const rootReducer = combineReducers({
  me,
  org,
  jobs,
  applications,
  comments,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
